import { env } from '@/infra/config/env'

export const API_ENDPOINTS = {
  USER_INITIALIZE: env.USER_INITIALIZE_PATH,
  USER_ONBOARD: env.USER_ONBOARD_PATH,
  COMMAND_SUBMIT: env.COMMAND_SUBMIT_PATH,
  API_KEY_GENERATE: env.API_KEY_GENERATE_PATH,
  API_KEY_LIST: env.API_KEY_LIST_PATH,
  API_KEY_REVOKE: env.API_KEY_REVOKE_PATH,
  HOST_ADD: env.HOST_ADD_PATH,
  HOST_LIST: env.HOST_LIST_PATH,
  HOST_LIST_PAGINATED: env.HOST_LIST_PAGINATED_PATH,
  HOST_DELETE: env.HOST_DELETE_PATH,
  HOST_PROJECTS: env.HOST_PROJECTS_PATH,
  SESSIONS_LATEST: env.SESSIONS_LATEST_PATH,
  SESSION_STATUSES: env.SESSION_STATUSES_PATH,
  HOST_STATUSES: env.HOST_STATUSES_PATH,
} as const

export type ApiEndpoint = keyof typeof API_ENDPOINTS
